import React from 'react'

const CheckIcon = (
  <path
    d="M20.7137 0.431152H19.0005C18.7603 0.431152 18.5324 0.541442 18.3853 0.73016L8.28036 13.5311L3.43496 7.39166C3.36166 7.2986 3.26823 7.22335 3.16169 7.17156C3.05515 7.11977 2.93825 7.0928 2.81979 7.09265H1.10662C0.942414 7.09265 0.851731 7.28137 0.952218 7.40882L7.66519 15.9134C7.9789 16.3104 8.58182 16.3104 8.89798 15.9134L20.8681 0.744865C20.9686 0.61987 20.8779 0.431152 20.7137 0.431152Z"
    fill="#22D3B6"
  />
)

export default CheckIcon
